import { render, staticRenderFns } from "./ReportsComponent.vue?vue&type=template&id=f66f264c&scoped=true&"
import script from "./ReportsComponent.vue?vue&type=script&lang=js&"
export * from "./ReportsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f66f264c",
  null
  
)

export default component.exports